import { useTranslation } from "react-i18next";
import { Outlet, Link, useMatch, useParams } from "react-router-dom";

import { DEFAULT_LOCALE, isSupportedLocale } from "@/i18n/config";
import { LanguageSelector } from "@/i18n/LanguageSelector";

/**
 * RootLayout — customer SPA の最小共通レイアウト。
 *
 * 各 feature 画面 (home / upload / respond / result) はこの下に Outlet で展開される。
 * ヘッダにはサービス名と言語切替のみ。顧客名・期間など URL に依存する文脈は
 * 取り違え対策の観点で各画面側で個別に表示する。
 *
 * 社労士事務所向けアップロードページ (/:lang/u/...) は国内法人想定 (ADR-0017) で
 * 言語選択が不要なため、言語切替 UI を非表示にする (ADR-0033 Decision 6)。
 * URL 直打ちでの言語切替 (/en/u/... 等) 自体は許容し、アクセス遮断はしない。
 */
export function RootLayout() {
  const { t } = useTranslation();
  const { lang } = useParams<{ lang: string }>();
  const current = isSupportedLocale(lang) ? lang : DEFAULT_LOCALE;
  const isOfficeInputRoute = useMatch("/:lang/u/*") !== null;

  return (
    <div className="min-h-dvh bg-background text-foreground">
      <header className="border-b border-border bg-card">
        <div className="flex items-center justify-between gap-4 px-6 py-4">
          <Link to={`/${current}`} className="text-lg font-semibold text-primary">
            {t("appName")}
          </Link>
          {!isOfficeInputRoute && <LanguageSelector />}
        </div>
      </header>

      <Outlet />
    </div>
  );
}
